import { IFalsificatViewDTO } from "../../libs/coreapi-dto/dirs/Falsificat";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class FalsificatDataProvider extends DictionaryDataProvider<IFalsificatViewDTO, IFalsificatViewDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IFalsificatViewDTO, IFalsificatViewDTO>> {
        return this._coreApiService.falsificatRequest
    }
}